<template>
    <sa-page-layout :btnRefreshVisible="true" @refresh="onRefresh" :showModalLoading="showModalLoading">
        <template slot="table-filter">
            <div style="width: 100%">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Nome:</label>
                        <span>{{ jsonData.nome }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Stanza:</label>
                        <span>{{ jsonData.nomeStanza }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Tipo letto:</label>
                        <span>{{ jsonData.tipoLetto }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Piano:</label>
                        <span>{{ jsonData.nomePiano }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Presidio:</label>
                        <span>{{ jsonData.denominazionePresidio }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Sesso:</label>
                        <span>{{ jsonData.descrizioneSesso }}</span>
                    </b-col>
                </b-row>
            </div>
        </template>
        <template slot="table-body">
            <rsa-storico-posto-letto-view-component ref="storicoPostoLettoView" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaStoricoPostoLettoViewComponent from "../components/RsaStoricoPostoLettoViewComponent.vue";
export default {
    mixins: [UtilityMixin],
    components: { SaPageLayout, RsaStoricoPostoLettoViewComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/rsapostilettolettostatistorico",
            pathResourceLetto: "/rsapostilettoletti",
            idLetto: null,
            jsonData: {
                username: null,
            },
        };
    },
    mounted() {
        let me = this;
        this.idLetto = this.$route.params.id;
        me.loadDataLetto();
        this.$nextTick(() => {
            if (me.$refs.storicoPostoLettoView) {
                me.$refs.storicoPostoLettoView.loadData(me.idLetto);
            }
        });
    },
    methods: {
        loadDataLetto() {
            let me = this;
            me.showModalLoading = true;
            me.jsonData.id = me.$route.params.id;
            me.loadDataResources(me.pathResourceLetto + "/" + me.jsonData.id, {}, me.loadDataLettoSuccess, me.loadDataLettoError);
        },
        loadDataLettoSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.showModalLoading = false;
        },
        loadDataLettoError(error) {
            let me = this;
            console.log("Errore nel caricamento dei dati del letto", error);
            me.showModalLoading = false;
        },
        onRefresh() {
            let me = this;
            me.$refs.storicoPostoLettoView.loadData(me.idLetto);
        },
    },
};
</script>

<style></style>
